<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
      font-weight: 400;
      color: #424242;">
        <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;
          Software Management</h5>
      </div>
<div id="mainContent" class="container">
    <div class="pt-3 pb-2">
            <div class="row">
              <div class="col-sm-4">
                <div class="row" *ngIf="showAddSoftwareButton">
                  <label class="col-sm-2 col-form-label">Branch</label>
                  <div class="col-sm-7">
                    <select
                      class="form-control form-control-xs"
                      id="BranchName"
                      name="BranchName"
                      [(ngModel)]="selectBranch"
                      (change)="onBranchChange()"
                    >
                      <option [ngValue]="null">Select Branch</option>
                      <option *ngFor="let branchName of branchList" [ngValue]="branchName">
                        {{ branchName.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

            <div class="col-md-4" >
              <div class="row" *ngIf="showAddSoftwareButton">
                <div class="col-md-2">
                <label class="col-form-label"
                  >Status</label
                >
                </div>
                <div class="col-sm-6">
                  <select
                    class="form-control form-control-xs mt-1"
                    [(ngModel)]="selectedEmployeeStatus"
                    (change)="getAllSoftwareAssetsList()"
                  >
                    <option value="all">All</option>
                    <option value="assigned">Assigned</option>
                    <option value="instock">Instock</option>
                    <!-- <option value="blocked">Blocked</option> -->
                    <option value="retired">Retired</option>
                  </select>
                </div>
              </div>
            </div>
            
            <!-- <div class="col-md-4"> -->
              <!-- <div class="input-group">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  placeholder="Serial / Service Tag Number"
                />
                (ngModelChange)="afterSearchSerialTagNumber($event)"
                [(ngModel)]="searchSerialTagNumber"

                <div class="input-group-append">
                  <button
                    class="btn btn-theme btn-xs"
                    type="submit"
                    id="button-addon2"
                  >
                  (click)="searchSerialTagNumberList()"
                    Search
                  </button>
                </div>
              </div> -->
          <!-- </div> -->

            <div class="col-md-4">
            <div class="row">
            <div class="col-md-8">
              <button
                class="btn btn-xs btn-theme"
                style="float: right"
                matTooltip="Click to add"
                matTooltipPosition="left"
                (click)="openModal(modalContent)"
                *ngIf="showAddSoftwareButton"
              >
                <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Add
              </button>
            </div>
            <div class="col-md-4">
              <button
                class="btn btn-xs btn-theme"
                style="float: right"
                matTooltip="Click to add"
                matTooltipPosition="left"
                (click)="openTransferModal(TransferModalContent)"
                *ngIf="showAddSoftwareButton"
              >
                <i class="fa fa-plus-square" aria-hidden="true"></i>&nbsp;Transfer
              </button>
            </div>
          </div>
          </div>
          </div>
      <div class="pt-2" >
          <!-- style="display: block; overflow-x: auto; white-space: nowrap" -->
          <table class="table table-bordered table-sm table-striped">
            <thead class="">
              <tr>
                <th *ngIf="showAddSoftwareButton">Action</th>
                <th>Sr.No.</th>
                <th>Service / Serial Tag</th>
                <th>Type Of Software</th>
                <th>Software Name</th>
                <th>Hardware Name</th>
                <th>Expiry Date</th>
                <th>Branch</th>
                <th *ngIf="showAddSoftwareButton">Status</th>
              </tr>
            </thead>
            <tbody *ngFor="let data of softwareAssetsList;let i=index;">
              
                <td *ngIf="showAddSoftwareButton">
                  <a
              style="color: #800000; cursor: pointer;padding-left:10px;text-decoration: underline;"
              (click)="viewSoftwareAssets(data.software,viewModalContent)">
             <span>View</span>
            </a>
              <a
                style="color: #800000; cursor: pointer;padding-left:10px;text-decoration: underline;"
                (click)="editSoftwareAsset(data.software,modalContent)"
              >
              <span *ngIf="!data.software.block">Edit</span>
              </a>
                </td>
              <td>{{i+1}}</td>
              <td>{{data.software.serviceTagNumber}}</td>
              <td>{{data.software.subType.name}}
               <!--  <tr>
                <span
                *ngFor="
                  let data of softwareAssetsList.subType;
                  let i = index;
                  let first = first;
                  let last = last
                "
              >
                {{ data.name }}
                <span *ngIf="i < softwareAssetsList.subType.length && !last">
                  ,
                </span>
                <span *ngIf="last"> . </span>
              </span></tr> -->
              
              <td>{{data.software.assetName}}</td>
              <td>{{data.hardware!=null?data.hardware.assetName:'InStock'}}</td>
              <td>{{data.software.expiryDate!=null?data.software.expiryDate:'NA'}}</td>
              <td>{{data.software.branch.name}}</td>
              <td *ngIf="showAddSoftwareButton">{{getSoftwareStatus(data)}}</td>
            </tbody>
          </table>
        </div>
    </div>
</div>
</div>
<ng-template #modalContent let-modal>
    <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
      <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
        Add Software
      </h5>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-sm-6" *ngIf="hideSaveButton">
                <div class="row">
                  <div class="col-sm-4">
                    <label class="col-form-label">
                        Service / Serial Tag<span class="text-danger">*</span>
                    </label>
                  </div>
                  <div class="col-sm-8">
                    <input
                      type="text"
                      id="serialTag"
                      name="serialTag"
                      class="form-control form-control-xs"
                      [(ngModel)]="assetsManagementModel.serviceTagNumber"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="row">
                  <label class="col-sm-4 col-form-label"
                    >Type Of Software<span class="text-danger">*</span>
                  </label>
                  <div class="col-sm-8">
                    <select
                      class="form-control form-control-xs"
                      id="softwareType"
                      name="softwareType"
                      [(ngModel)]="assetsManagementModel.subType"
                    >
                      <option [ngValue]="null">Select Software Type</option>
                      <option *ngFor="let type of softwareAssetsTypeList.subType" [ngValue]="type">
                        {{ type.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
        </div>
      <div class="row">
        <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                   Software Name<span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  id="softwareName"
                  name="softwareName"
                  class="form-control form-control-xs"
                  [(ngModel)]="assetsManagementModel.assetName"
                />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                    Software Product Key<span class="text-danger">*</span>
                </label>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  id="softwarePurchaseKey"
                  name="softwarePurchaseKey"
                  class="form-control form-control-xs"
                  [(ngModel)]="assetsManagementModel.productKey"
                />
              </div>
            </div>
          </div>
      </div>

        <div class="row">

          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Date Of Purchase<span class="text-danger">*</span>
              </label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="purchaseDate"
                    name="purchaseDate"
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    ngbDatepicker
                    #purchaseDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.dateOfPurchase"
                  />
    
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar btn-xs"
                      (click)="purchaseDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Branch<span class="text-danger">*</span>
              </label>
              <div class="col-sm-8">
                <select
                  class="form-control form-control-xs"
                  id="BranchName"
                  name="BranchName"
                  [(ngModel)]="assetsManagementModel.branch"
                >
                  <option [ngValue]="null">Select Branch</option>
                  <option *ngFor="let branchName of branchList" [ngValue]="branchName">
                    {{ branchName.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>

        <div class="row">         
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Expiry Date
              </label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="expiryDate"
                    name="expiryDate"
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    ngbDatepicker
                    #expiryDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.expiryDate"
                  />
    
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar btn-xs"
                      (click)="expiryDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                  Photo PGB Purchase accounting voucher no.
                </label>
              </div>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <input
                      type="file"
                      id="pgbPurchaseVoucherPhoto"
                      name="pgbPurchaseVoucherPhoto"
                      (change)="fileChange($event,'pgbPurchaseVoucherPhoto')"  
                    />
                    </div>
                      <div class="col-sm-6" *ngIf="assetsManagementModel.pgbPurchaseVoucherPhotoUrl != null">
                  <a href="{{ assetsManagementModel.pgbPurchaseVoucherPhotoUrl }}" target="_blank" rel="noopener noreferrer">
                    <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                  <!-- <span>{{ assetsManagementModel.pgbPurchaseVoucherPhotoUrl }}</span> -->
                </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6" >
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                  PGB Purchase accounting voucher no.  
                </label>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  id="pgbPurchaseAccountingVoucherNo"
                  name="pgbPurchaseAccountingVoucherNo"
                  class="form-control form-control-xs"
                  [(ngModel)]="assetsManagementModel.pgbPurchaseAccountingVoucherNo"
                />
              </div>
            </div>
          </div>
    
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >PGB Purchase accounting voucher date
              </label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="pgbPurchaseAccountingVoucherDate"
                    name="pgbPurchaseAccountingVoucherDate"
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    ngbDatepicker
                    #pgbPurchaseAccountingVoucherDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.pgbPurchaseAccountingVoucherDate"
                  />
    
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar btn-xs"
                      (click)="pgbPurchaseAccountingVoucherDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6" >
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                  Vendor Invoice No.
                </label>
              </div>
              <div class="col-sm-8">
                <input
                  type="text"
                  id="vendorInvoiceNo"
                  name="vendorInvoiceNo"
                  class="form-control form-control-xs"
                  [(ngModel)]="assetsManagementModel.vendorInvoiceNo"
                />
              </div>
            </div>
          </div>
          
        
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Vendor Invoice date
              </label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="vendorInvoiceDate"
                    name="vendorInvoiceDate"
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    ngbDatepicker
                    #vendorInvoiceDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.vendorInvoiceDate"
                  />
    
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar btn-xs"
                      (click)="vendorInvoiceDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label class="col-form-label">
                  Photo of Vendor Invoice
                </label>
              </div>
                <div class="col-sm-8">
                  <div class="row">
                    <div class="col-sm-6">
                      <input
                      type="file"
                      id="vendorInvoicePhoto"
                      name="vendorInvoicePhoto"
                      (change)="fileChange($event,'vendorInvoicePhoto')"  
                    />
                    </div>
                       <div class="col-sm-6" *ngIf="assetsManagementModel.vendorInvoicePhotoUrl != null">
                  <a href="{{ assetsManagementModel.vendorInvoicePhotoUrl }}" target="_blank" rel="noopener noreferrer">
                    <i class="fa fa-download fa-lg" aria-hidden="true"></i> </a>
                  <!-- <span>{{ assetsManagementModel.vendorInvoicePhotoUrl }}</span> -->
                </div>
                  </div>
                  
                </div>
              </div>
          </div>
        </div>
        <!-- <div class="row" *ngIf="hideSaveButton">
          <div class="col-sm-6">
            <div class="row">
              <label class="col-sm-4 col-form-label"
                >Date Of Release<span class="text-danger">*</span>
              </label>
              <div class="col-sm-8">
                <div class="input-group">
                  <input
                    id="releaseDate"
                    name="releaseDate"
                    class="form-control form-control-xs"
                    placeholder="dd/mm/yyyy"
                    ngbDatepicker
                    #releaseDate="ngbDatepicker"
                    [(ngModel)]="assetsManagementModel.dateOfSale"
                  />
    
                  <div class="input-group-append">
                    <button
                      class="btn btn-outline-theme calendar btn-xs"
                      (click)="releaseDate.toggle()"
                      type="button"
                    ></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
           <div class="col-sm-6">
                <div class="row">
                  <div class="col-sm-4">
                    <label class="col-form-label">
                      Comments
                    </label>
                  </div>
                  <div class="col-sm-8">
                    <textarea
                      type="text"
                      id="comments"
                      name="comments"
                      class="form-control form-control-xs"
                      [(ngModel)]="assetsManagementModel.comment"
                    ></textarea>
                  </div>
                </div>
              </div>
        </div>

    </div>

    <div class="modal-footer">
        <div class="row col-md-12">
          <div class="col-md-6"></div>
          <div class="col-md-3">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onAddSoftwareAsset()"
              *ngIf="!hideSaveButton"
            >
              Save
            </button>
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-theme"
              (click)="onAddSoftwareAsset()"
              *ngIf="hideSaveButton"
            >
              Update
            </button>
          </div>
          <div class="col-sm-3">
            <button
              type="button"
              class="btn btn-sm btn-block btn-outline-secondary"
              (click)="closeModal()"
            >
              Close
            </button>
          </div>
        </div>
    </div>
</ng-template>

<ng-template #TransferModalContent let-modal>
  <div class="modal-header bg-theme bg-theme-txt pt-2 pb-2">
    <h5 class="modal-title" id="modal-basic-title" style="text-align: center">
      Transfer Software
    </h5>
  </div>
  <div class="modal-body">

      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Service / Serial Tag<span class="text-danger">*</span>
        </label>
        <div class="col-sm-8">
          <select
            class="form-control form-control-xs"
            id="serviceTagNumber"
            name="serviceTagNumber"
            [(ngModel)]="selectedTransferServiceTag"
            (change)="setFromUserValue()">
            <option [ngValue]="null">Select Serial Tag Number</option>
            <option *ngFor="let srialTagName of serialTagList" [ngValue]="srialTagName">
              {{ srialTagName.serviceTagNumber }}
            </option>
          </select>
        </div>
      </div>

      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Product Key<span class="text-danger">*</span>
        </label>
        <div class="col-sm-8">
          <input
          type="text"
          id="make"
          name="make"
          class="form-control form-control-xs"
          [(ngModel)]="showProductKey"
          disabled
        />
        <!-- <span>{{showtransferFromValue}}</span> -->
      </div>
      </div>

      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Transfer From<span class="text-danger">*</span>
        </label>
        <div class="col-sm-8">
          <input
          type="text"
          id="make"
          name="make"
          class="form-control form-control-xs"
          [(ngModel)]="showtransferFromValue"
          disabled
        />
        <!-- <span>{{showtransferFromValue}}</span> -->
      </div>
      </div>

      <div class="row">
        <label class="col-sm-4 col-form-label"
          >Transfer To<span class="text-danger">*</span>
        </label>
        <div class="col-sm-8">
          <select
            class="form-control form-control-xs"
            id="transerTo"
            name="transerTo"
            [(ngModel)]="transferTo"
          >
            <option value="">Select Transfer To</option>
            <option *ngFor="let serviceTagData of hardwareSerialTagList" [ngValue]="serviceTagData">
              {{ serviceTagData.serviceTagNumber }} 
            </option>
          </select>
        </div>
      </div>

  <div class="row">
      <label class="col-sm-4">Transfer Date<span class="text-danger">*</span>
      </label>
    <div class="col-sm-8">
      <div class="input-group">
        <input
          class="form-control form-control-xs"
          placeholder="dd/mm/yyyy"
          name="requsetDate"
          ngbDatepicker
          #requsetDate="ngbDatepicker"
          [(ngModel)]="transferDate"
          [minDate]="previousMonthCurrentDate"
          [maxDate]="currentDate"
        />
        <div class="input-group-append">
          <button
            class="btn btn-outline-theme calendar"
            (click)="requsetDate.toggle()"
            type="button"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>

  <div class="modal-footer" style="">
      <div class="row col-md-12">
        <div class="col-md-6"></div>
        <div class="col-md-3">
          <button
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="excuteTransferDetails()"
          >
            Execute
          </button>
          <!-- <button
            type="button"
            class="btn btn-sm btn-block btn-outline-theme"
            (click)="onUpdateClick()"
            *ngIf="hideSaveButton"
          >
            <span *ngIf="!buttonChangeStatus">Update</span>
            <span *ngIf="buttonChangeStatus">Update & Submit</span>
          </button> -->
        </div>
        <div class="col-sm-3">
          <button
            type="button"
            class="btn btn-sm btn-block btn-outline-secondary"
            (click)="closeModal()"
          >
            Close
          </button>
        </div>
      </div>
  </div>
</ng-template>

<ng-template #viewModalContent let-modalView>
  <div class="modal-header bg-theme bg-theme-txt">
    <h5 class="modal-title" id="modal-basic-title">View Software Details</h5>
  </div>
  <div class="modal-body">
    <div class="row mb-1">
      <div class="col-sm-6">
      <div class="row">
      <div class="col-sm-6"><label>Service Tag Number</label></div>
      <div class="col-sm-6">
        <label>: &nbsp;&nbsp;</label>
        <span>{{viewSoftwareAssetDetails.serviceTagNumber}}</span>
      </div>
    </div>
    </div>
    <div class="col-sm-6">
      <div class="row">
        <div class="col-sm-6"><label>Type Of Software</label></div>
        <div class="col-sm-6">
          <label>: &nbsp;&nbsp;</label>
          <span>{{viewSoftwareAssetDetails.subType.name}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-6">
    <div class="row">
    <div class="col-sm-6"><label>Software Name</label></div>
    <div class="col-sm-6">
      <label>: &nbsp;&nbsp;</label>
      <span>{{viewSoftwareAssetDetails.assetName}}</span>
    </div>
  </div>
  </div>
  <div class="col-sm-6">
    <div class="row">
      <div class="col-sm-6"><label>Software Product Key</label></div>
      <div class="col-sm-6">
        <label>: &nbsp;&nbsp;</label>
        <span>{{viewSoftwareAssetDetails.productKey}}</span>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-sm-6">
  <div class="row">
  <div class="col-sm-6"><label>Expiry Date </label></div>
  <div class="col-sm-6">
    <label>: &nbsp;&nbsp;</label>
    <span>{{viewSoftwareAssetDetails.expiryDate | date:'dd-MMMM-yyyy'}}</span>
  </div>
</div>
</div>
<div class="col-sm-6">
  <div class="row">
    <div class="col-sm-6"><label>Date Of Purchase</label></div>
    <div class="col-sm-6">
      <label>: &nbsp;&nbsp;</label>
      <span>{{viewSoftwareAssetDetails.dateOfPurchase | date:'dd-MMMM-yyyy'}}</span>
    </div>
  </div>
</div>
</div>

<div class="row">
  <!-- <div class="col-sm-6">
    <div class="row">
      <div class="col-sm-6"><label>Date Of Sale</label></div>
      <div class="col-sm-6">
        <label>:&nbsp;&nbsp;</label>
        <span>{{viewSoftwareAssetDetails.dateOfSale |date:'dd-MMMM-yyyy'}}</span>
      </div>
    </div>
  </div> -->

  <div class="col-sm-6">
    <div class="row">
      <div class="col-sm-6"><label>Branch</label></div>
      <div class="col-sm-6">
        <label>: &nbsp;&nbsp;</label>
        <span>{{viewSoftwareAssetDetails.branch.name}}</span>
      </div>
    </div>
  </div>

  <div class="col-sm-6">
  <div class="row">
  <div class="col-sm-6"><label>Comments</label></div>
  <div class="col-sm-6">
    <label>: &nbsp;&nbsp;</label>
    <span>{{viewSoftwareAssetDetails.comment}}</span>
  </div>
</div>
</div>

</div>
  </div>
  <div class="modal-footer" style="">
    <div class="row col-md-12">
      <div class="col-sm-9"></div>
      <div class="col-sm-3">
        <button
          id="closeAssignmentBtn"
          name="closeAssignmentBtn"
          type="button"
          class="btn btn-sm btn-block btn-outline-secondary"
          (click)="modalView.dismiss('Cross click')"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</ng-template>